import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import PropTypes from "prop-types";
import BaseIcon from "../../../../components/BaseIcon";
import "./style.scss";
import AnswerTitle from "../../../InsightQuestionnaireFormPage/components/AnswerTitle";

export default function DropDownAnswer({ title, name, number, question }) {
  DropDownAnswer.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };
  const numRef = useRef();
  const { t } = useTranslation();

  const [valueNumber, setValueNumber] = useState(0);
  const [valuePeriod, setValuePeriod] = useState("week");

  const onValueChange = (event) => {
    if (event.target.type === "number") {
      /* empty */
      if (event.target.value > 100 || event.target.value < 0) return;
      setValueNumber(event.target.value);
    }
    if (event.target.type === "select-one") {
      /* empty */
      setValuePeriod(event.target.value);
    }
  };

  const onStep = (typeStep) => {
    setValueNumber((prevState) =>
      typeStep === "+" ? prevState + 1 : prevState - 1
    );
  };

  const parsedAnswer = useMemo(() => {
    const parsedValueUserAnswer = question.userAnswer?.value.split(":") || [
      " ",
      " ",
    ];
    const parsedValuePartnerAnswer = question.partnerAnswer?.value.split(
      ":"
    ) || [" ", ""];
    const userAnswer = {
      number: +parsedValueUserAnswer[0],
      period: parsedValueUserAnswer[1],
    };
    const partnerAnswer = {
      number: +parsedValuePartnerAnswer[0],
      period: parsedValuePartnerAnswer[1],
    };
    return {
      userAnswer,
      partnerAnswer,
    };
  }, [question.partnerAnswer?.value, question.userAnswer?.value]);
  return (
    <BaseFormBlock>
      <div className="dropdown-answer-both">
        <AnswerTitle title={title} number={number} />
        {question.userAnswer?.value ? (
          <div className="dropdown-answer-both__input-wrapper">
            <div className="dropdown-answer-both__label">
              {t("insight_questionnaire_form_page.myAnswer")}
            </div>
            <div className="dropdown-answer-both__gradient_wrapper">
              <input
                disabled
                ref={numRef}
                className="dropdown-answer-both__number"
                name={name}
                type="number"
                min="0"
                max="100"
                value={parsedAnswer.userAnswer.number}
                onChange={(event) => onValueChange(event)}
              />
              <div className="dropdown-answer-both__number-arrows">
                <BaseIcon onClick={() => onStep("+")} name="top_triangle" />
                <BaseIcon onClick={() => onStep("-")} name="bottom_triangle" />
              </div>
            </div>
            <div className="dropdown-answer-both__gradient_wrapper">
              <select
                className="dropdown-answer-both__select"
                onChange={(event) => onValueChange(event)}
                name={name}
                value={parsedAnswer.userAnswer.period}
                placeholder={t("insight_questionnaire_form_page.myAnswer")}
              >
                <option value="week" defaultValue="week">
                  {t("insight_questionnaire_form_page.inWeek")}
                </option>
                <option value="month">
                  {t("insight_questionnaire_form_page.inMonth")}
                </option>
                <option value="year">
                  {t("insight_questionnaire_form_page.inYear")}
                </option>
              </select>
            </div>
          </div>
        ) : null}

        {question.userAnswer?.value ? (
          <div className="dropdown-answer-both__input-wrapper">
            <div className="dropdown-answer-both__label">
              {t("insight_questionnaire_form_page.partnerAnswer")}
            </div>
            <div className="dropdown-answer-both__gradient_wrapper">
              <input
                disabled
                ref={numRef}
                className="dropdown-answer-both__number"
                name={name}
                type="number"
                min="0"
                max="100"
                value={parsedAnswer.partnerAnswer.number}
                onChange={(event) => onValueChange(event)}
              />
              <div className="dropdown-answer-both__number-arrows">
                <BaseIcon onClick={() => onStep("+")} name="top_triangle" />
                <BaseIcon onClick={() => onStep("-")} name="bottom_triangle" />
              </div>
            </div>
            <div className="dropdown-answer-both__gradient_wrapper">
              <select
                className="dropdown-answer-both__select"
                onChange={(event) => onValueChange(event)}
                name={name}
                value={parsedAnswer.partnerAnswer.period}
                placeholder={t("insight_questionnaire_form_page.myAnswer")}
              >
                <option value="week" defaultValue="week">
                  {t("insight_questionnaire_form_page.inWeek")}
                </option>
                <option value="month">
                  {t("insight_questionnaire_form_page.inMonth")}
                </option>
                <option value="year">
                  {t("insight_questionnaire_form_page.inYear")}
                </option>
              </select>
            </div>
          </div>
        ) : null}
      </div>
    </BaseFormBlock>
  );
}
